import { components } from "react-select";
import PropTypes from "prop-types";
import { memo, useEffect } from "react";
import "./LocationMenuList.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const LocationMenuList = ({ children, ...props }) => {
	const { selectProps } = props;
	useEffect(() => {
		const selectedEl = document.getElementsByClassName("location-menu-list")[0];
		if (selectedEl) {
			selectedEl.scrollTo(0, 0);
		}
	}, [selectProps?.inputValue]);

	return (
		<components.MenuList className="location-menu-list" {...props}>
			{selectProps.isTopLocationMenuDisplayed && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL}
					isBold
					className="location-menu-list__top-departure-cities-label"
				>
					{selectProps.locationMenuLabel}
				</Typography>
			)}
			<div className="location-menu-list__container">{children}</div>
		</components.MenuList>
	);
};

LocationMenuList.propTypes = {
	selectProps: PropTypes.object,
};

export default memo(LocationMenuList);
